{
  "discounts_upsell": {
    "title": "Manage Discounts",
    "subtitle": "Discounts let you set up promotions for your B2B customers (independent of your B2C customers) that work alongside any price list rules you have set up.",
    "learn_button": "Learn more",
    "intro": "Here are just some of the things you can do with the SparkLayer Discount Engine:",
    "features": {
      "discount_types": {
        "title": "Automatic or coupon-based discounts",
        "description": "Set discounts to apply automatically when conditions are met, or let customers enter coupon codes at checkout."
      },
      "targeted_discounts": {
        "title": "Target by customer group, order value, or products",
        "description": "Apply discounts to specific B2B customer groups, set minimum order thresholds, or target specific SKUs and product tags."
      },
      "reward_discounts": {
        "title": "Free products, shipping rewards, and more",
        "description": "Go beyond percentage-off - add free products to orders, offer free shipping over a threshold, or set fixed-price shipping for your wholesale buyers."
      }
    },
    "learn_more": "Learn more about the SparkLayer Discount Engine"
  },
  "list_table": {
    "caption": "Discounts",
    "views": {
      "all": "All",
      "active": "Active",
      "inactive": "Inactive"
    },
    "tooltips": {
      "coupon-required": "This discount requires the customer to enter a coupon code:",
      "coupon-not-required": "This discount does not require the customer to enter a coupon code.",
      "group-required": "This discount requires the customer to belong to a specific customer group:",
      "group-not-required": "This discount applies to all customer groups.",
      "scheduling-required": "This discount will be active {range, select, both {from <b>{start}</b> until <b>{end}</b>} start {from <b>{start}</b>} other {until <b>{end}</b>}}.",
      "scheduling-not-required": "This discount has no scheduling restrictions.",
      "spend-required": "This discount will be applied only if the cart sub-total is {range, select, both {at least <b>{min}</b> and lower than <b>{max}</b>} min {at least <b>{min}</b>} other {lower than <b>{max}</b>}}.",
      "spend-not-required": "This discount has no cart sub-total restrictions.",
      "num-items-required": "This discount will be applied only if the cart items quantity is {range, select, both {at least <b>{min}</b> and lower than <b>{max}</b>} min {at least <b>{min}</b>} other {lower than <b>{max}</b>}}.",
      "num-items-not-required": "This discount has no cart items quantity restrictions.",
      "max-uses-required": "Customers can use this discount a maximum of <b>{count, plural, =1 {# time} other {# times}}</b>.",
      "max-uses-not-required": "This discount has no maximum usage restrictions.",
      "excluded-customers-required": "Some customers are excluded from this discount.",
      "excluded-customers-not-required": "This discount has no excluded customers.",
      "products-required": "This discount requires specific products to be in the cart.",
      "products-not-required": "This discount has no product restrictions.",
      "simultaneity-required": "The following discounts may also be used when this discount is applied:",
      "simultaneity-required-all": "All discounts can be used with this discount.",
      "simultaneity-not-required": "No other discounts may be used with this discount.",
      "currency-required": "This discount is only valid for orders in the <b>{currency}</b> currency.",
      "currency-not-required": "This discount has no currency restrictions."
    },
    "headings": {
      "internal_name": "internal name",
      "type": "type",
      "requirements": "requirements",
      "status": "status"
    },
    "search": "Search discounts",
    "filters": {
      "type": "Type",
      "types": {
        "order_level_get_amount_off": "Give an amount off an order",
        "order_level_get_free_product": "Give a free product",
        "product_level_get_amount_off": "Give a percentage off products",
        "order_level_get_shipping_reward": "Give a shipping reward",
        "advanced_order_level_get_amount_off": "Give an amount off an order with advanced requirements",
        "order_level_requirement_amount_off": "Requirements",
        "advanced_discount": "Advanced requirements and rewards",
        "advanced_free_products": "Advanced free products"
      }
    },
    "sort": {
      "default": "Priority",
      "name": "Name"
    }
  },
  "discounts_delete_modal": {
    "title": "Delete discount",
    "description": "Are you sure you want to delete the \"{name}\" discount?",
    "status": {
      "errors": {
        "delete_failed": "Failed to delete discount."
      },
      "success": {
        "delete_succeeded": "Discount \"{name}\" successfully deleted."
      }
    }
  }
}
